import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LayoutPageAccountComponent } from './layout-page-account.component';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';

@NgModule({
  declarations: [
    LayoutPageAccountComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    ButtonModule
  ],
  exports: [
    LayoutPageAccountComponent
  ]
})
export class LayoutPageAccountModule { }
